/**
 * Occupational Therapy Missed Visit Report — options + empty payload.
 * After shared common header (1–6): Reason → Attempts → Impact on POC →
 * Physician notification → Notification log → Next visit → Notes
 * (per OT Missed Visit Report screenshots).
 */

import { emptyOtCommonHeader } from "./otNotesCommonHeaderUtils";

/** Row-major order so a 2-column grid matches the screenshot columns. */
export const MISSED_REASON_OPTIONS = [
  "Patient/Caregiver not available",
  "Cancelled/Rescheduled",
  "Refused visit",
  "Not feeling well",
  "Hospitalized",
  "Out of town",
  "Inclement weather",
  "No safe access",
  "No caregiver present",
  "MD appointment",
];

export const ATTEMPT_COUNT_OPTIONS = ["1", "2", "3+"];

export const CONTACT_METHOD_OPTIONS = [
  "Phone Call",
  "SMS / Text",
  "Voicemail Left",
];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const NOTIFICATION_METHOD_OPTIONS = [
  "Phone",
  "Fax",
  "Email",
  "Portal",
  "Voicemail",
  "In Person",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable OT Missed Visit payload (JSON on dedicated row). */
export const emptyOtMissedVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  missedVisitDate: "",
  commonHeader: emptyOtCommonHeader(),

  // —— 7. Reason for Missed Visit ——
  missedReasons: [],
  reasonOtherSpecify: "",

  // —— 8. Attempts Made ——
  attemptsCount: "",
  contactMethods: [],

  // —— 9. Impact on Plan of Care ——
  awareOfNextVisit: "",
  planToMakeUpVisit: "",
  interventionsAffected: "",
  functionalImpact: "",

  // —— 10. Physician / Case Manager Notification ——
  notificationMethod: "",
  personNotified: "",
  notificationDate: "",
  notificationTime: "",
  notificationDetails: "",

  // —— 11. Notification Log ——
  notifiedBy: "",
  contactPerson: "",
  logDate: "",
  logTime: "",

  // —— 12. Next Visit Information ——
  nextVisitDate: "",
  nextVisitTime: "",
  therapistAssigned: "",

  // —— 13. Additional Notes ——
  additionalNotes: "",
});

export const OT_MISSED_ARRAY_KEYS = ["missedReasons", "contactMethods"];
